module.exports = __webpack_public_path__ + "media/footer/ig-eb2ccef1.svg";